import { defineComponent as _defineComponent } from 'vue'
import { ImageLoader } from '@tencent/wphk-components-content-loader';


export default /*#__PURE__*/_defineComponent({
  __name: 'merchant-bg',
  props: {
    img: null,
    name: null
  },
  setup(__props: any) {




return { __sfc: true,ImageLoader }
}

})